import {AxiosResponse} from "axios";
import axios from "../api-instance";
import ENDPOINTS from "../consts/endpoints";
import {IDeleteOrganisationUserPayload, IOrganisationProfilePayload, IOrganisationSettings, IOrganisationUpdateCsvPayload, IOrganisationUserUpdatePayload} from "../common/organisation";

export type IOrganisationRepository = {
    getMyOrganisation: Function;
    getProfiles: Function;
    addProfile: Function;
    deleteUser: Function;
    changeOrganisationSettings: Function;
    updateProfile: Function;
    uploadProfiles: Function;
};
class OrganisationRepository implements IOrganisationRepository{
    private api = axios;
    private getData(response: AxiosResponse) {
        return response.data;
    }
    getMyOrganisation() {
        this.api.setHeaders();
        return this.api.get(`${ENDPOINTS.ORGANIZATIONS}/my`).then(this.getData);
    }
    getProfiles(alias: string) {
        this.api.setHeaders();
        return this.api.get(`${ENDPOINTS.ORGANIZATIONS}/${alias}/profiles`).then(this.getData);
    }
    addProfile({alias, profile}: IOrganisationProfilePayload) {
        this.api.setHeaders();
        return this.api.post(`${ENDPOINTS.ORGANIZATIONS}/${alias}/profiles`, [profile]).then(this.getData);
    }
    deleteUser({alias, userId}: IDeleteOrganisationUserPayload) {
        this.api.setHeaders();
        return this.api.delete(`${ENDPOINTS.ORGANIZATIONS}/${alias}/profiles/${userId}`).then(this.getData);
    }
    changeOrganisationSettings(params: IOrganisationSettings) {
        this.api.setHeaders();
        return this.api.put(`${ENDPOINTS.ORGANIZATIONS}/${params.alias}`, params).then(this.getData);
    }
    updateProfile({id, ...rest}: IOrganisationUserUpdatePayload) {
        this.api.setHeaders();
        return this.api.put(`${ENDPOINTS.PROFILES}/${id}`, rest).then(this.getData);
    }
    uploadProfiles({alias, file}: IOrganisationUpdateCsvPayload) {
        this.api.setHeaders();
        return this.api.post(
            `${ENDPOINTS.ORGANIZATIONS}/${alias}/profiles/import/csv`,
            file,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then(this.getData);
    }
}

export default OrganisationRepository;